import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchWhatsAppMissingCountries, fetchWhatsAppRates, saveWhatsAppRate } from '../services/whatsapp-rates';

export const whatsappRateKeys = {
  all: ['whatsapp-rates'] as const,
  list: () => [...whatsappRateKeys.all, 'list'] as const,
  missing: () => [...whatsappRateKeys.all, 'missing'] as const,
};

export function useWhatsAppRates() {
  return useQuery({ queryKey: whatsappRateKeys.list(), queryFn: fetchWhatsAppRates });
}

/** Feeds the nav bubble; pass `enabled` only for system admins, the endpoint refuses everyone else. */
export function useWhatsAppMissingCountries(enabled = true) {
  return useQuery({
    queryKey: whatsappRateKeys.missing(),
    queryFn: fetchWhatsAppMissingCountries,
    staleTime: 1000 * 30,
    enabled,
  });
}

function useWhatsAppRateMutation<T>(mutationFn: (input: T) => Promise<unknown>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    // Awaited so the sheet's Save stays disabled until the refetched rates land.
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: whatsappRateKeys.all });
    },
  });
}

export function useSaveWhatsAppRate() {
  return useWhatsAppRateMutation(saveWhatsAppRate);
}
